import React, { Component } from 'react';
import styled from '@emotion/styled';
import cognitoUtils from '../lib/cognitoUtils';
import { connect, ConnectedProps } from 'react-redux'
import { initSessionFromCookie } from "../actions/session";
import { Link } from "react-router-dom";

interface RootState {
  session: any
}
type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & {
  session: any,
  initSessionFromCookie: any
}

const mapStateToProps = (state: RootState) => {
  return { session: state.session }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    initSessionFromCookie: () => dispatch(initSessionFromCookie())
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps)


class Header extends Component<Props, {}> {
  constructor(props: Props) {
    super(props)
    this.props.initSessionFromCookie()
  }

  render() {
    const onSignOut: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
      e.preventDefault();
      cognitoUtils.signOutCognitoSession();
    };

    return (
      <StyledContainer>
        <div className="logoContainer">
          <Link to="/">
            <img src="/gritsee-grey.png" alt="logo" />
          </Link>
        </div>
        {
          this.props.session.isLoggedIn ? (
            <div className="menuContainer">
              <a href="/orders" className="active">ORDERS</a>
            </div>) : ''
        }
        {
          this.props.session.isLoggedIn ? (
            <div className="signOutContainer">
              <a href="/logout" onClick={onSignOut}>SIGN OUT</a>
            </div>) : ''
        }
      </StyledContainer >
    );
  };
}

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 44px 52px 0;
  
  img {
    height: 43px;
    width: 124px;
  }
      
  .logoContainer {
    flex-shrink: 1;
  }
      
  .menuContainer {
    margin-left: 75px;
    flex-grow: 1;
    color: #6E757C;
    margin-top: -3px;
  }
    
  .menuContainer a {
    margin: 0 17px;
    color: #6E757C;
    text-decoration: none;
  }
    
  .menuContainer a.active {
    margin: 0 17px;
    font-weight: 600;
    color: #325882;
    text-underline-offset: 7px;
    text-decoration: underline 2px;
  }
      
  .signOutContainer {
    justify-self: end;
    flex-shrink: 1;
    margin-top: -3px;
    min-width: 100px;
    text-align: right;
  }
  
  .signOutContainer a {
    color: #6E757C;
    text-decoration: none;
    font-size: 12px;
  }
`;

export default connector(Header);